import vue from "../main"
import moment from "moment"
import { add_action_log, } from "@/api/common";
import ajaxRequest from "@/api/ajax_download.js"
import download_file from "downloadjs";
import OSS from "ali-oss"
function OssUpload(sts, options) {
  const is_function = typeof options === "function"
  const default_options = {
    // 获取分片上传进度、断点和返回值。p, cpt, res
    progress: is_function && options,
    // 设置并发上传的分片数量。
    parallel: 4,
    // 设置分片大小。默认值为1 MB，最小值为100 KB。
    partSize: 1024 * 1024,
    // headers,
    // 自定义元数据，通过HeadObject接口可以获取Object的元数据。
    // meta: { year: 2020, people: "test" },
    // mime: "text/plain",
  }
  this.client = new OSS(sts);
  if (is_function || !options) {
    this.options = default_options
  } else {
    this.options = options;
  }
}
// OssUpload.prototype = this.client
OssUpload.prototype.multipartUpload = function (fileName, file, successCb) {
  this.client.multipartUpload(fileName, file, {...this.options}).then(res => {
    successCb(res)
  }).catch(err => {
    console.log(err)
  })
}
const util = {
  OssUpload,
   // 下载文件, filename需要包括后缀名
   downloadFile(url, filename) {
     ajaxRequest(url, { responseType: 'blob' }).then(res => {
       download_file(res, filename, res.type)
     })
  },
  format_time(time) {
    const time_obj = moment.duration(time, "seconds");
    const hour = String(time_obj.hours()).padStart(2, "0");
    const min = String(time_obj.minutes()).padStart(2, "0");
    const seconds = String(time_obj.seconds()).padStart(2, "0");
    return hour + ":" + min + ":" + seconds;
  },
  formatDate(date,str){
    return moment(date).format(str)
  },
  getVideoInfo(file){
   return new Promise((resolve, reject) => {
     let url = URL.createObjectURL(file);
     const audioElement = new Audio(url)
     audioElement.addEventListener('loadedmetadata', function () {
       resolve(audioElement.duration);
       URL.revokeObjectURL(url);
     })
   });

  },
  // 抓取当前页中当前视频的当时截图(注：抓取的是阿里云播放器的video元素)quality:0 - 1.0
  getCurrentSnapShot(selector,quality) {
    // let c = document.getElementById('forSnapShot')
    let c = document.createElement("canvas")
    let video = document.querySelector(selector).children[0];
    let width = video.videoWidth
    c.setAttribute("width", width)
    let height = video.videoHeight
    c.setAttribute("height", height)
    let ctx = c.getContext("2d");
    ctx.drawImage(video, 0, 0, width, height, 0, 0, width, height);
    let fullQualityJPG = c.toDataURL("image/jpeg", quality);// 图片质量
    return fullQualityJPG
  },
  // editor_api_key: "i1be6sh5oujdbhrut4oj88osslawoa5h4p5r4ds33hyl6q7s",
  downloadExcel(blob, name) {
    let blobData = new Blob([blob]);
    let url = window.URL.createObjectURL(blobData);
    let link = document.createElement("a");
    link.href = url;
    let _d = moment().format("YYYYMMDDHHmmss");
    link.setAttribute("download", name + _d + ".xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  listTag(str) {
    if (typeof str === "string") {
      if(str.split(";").length > 1){
        // const arr = str.split(";");
        return str.split(";").join("<br/>");
      }
    }
  },
  //清空参数
  clearObject(obj) {
    Object.keys(obj).forEach((key) => (obj[key] = ''));
  },

  //添加editable的属性
  addEditable(obj, defaultEditable) {
    obj.forEach(item => {
      item.editable = defaultEditable == undefined ? false : defaultEditable;
    });

    return obj;
  },

  //统一success message box
  showSuccess(key) {
    let message = vue.$t("successMsg['" + key + "']");
    vue.$Message.success(message);
  },

  //统一error message box
  showError(key, object) {
    if(object == undefined)
    {
      object = {};
    }
    let message = vue.$t("errMsg['" + key + "']", object);
    vue.$Message.error({
      content: message,
      duration: 10,
      closable: true
    });
  },
   //统一warning message box
   showWarning(key) {
    let message = vue.$t("warningMsg['" + key + "']");
    vue.$Message.warning({
      content: message,
      duration: 10,
      closable: true
    });
  },

  //统一confirm的modal
  //object: msgKey, successCB, cancelCB
  confirmModal(obj) {
    // console.log(vue.$t("confirmMsg['" + obj.msgKey + "']", obj.formatMsg));

    vue.$Modal.confirm({
      title: obj.title ? obj.title : vue.$t("warning"),
      content: '<p>' + vue.$t("confirmMsg['" + obj.msgKey + "']", obj.formatMsg) + '</p>',
      okText: vue.$t('event_detail.confirmed_status.CONFIRMED'),
      cancelText: vue.$t('cancel'),
      onOk: () => {
        if (obj.successCB) obj.successCB();
      },
      onCancel: () => {
        if (obj.cancelCB) obj.cancelCB();
      }
    });
  },

  add_action_log(module, obj, event_id, session_id) {//增加操作日志
    let self = this;
    try {
      add_action_log({
        from_module: module,
        from_object: JSON.stringify(obj),
        event_id: event_id,
        session_id: session_id,
      }).then((res) => {

      });
    } catch (error) {

    }
  },

  //表格下载通用方法
  // downloadExcel(res, name) {
  //   let blob = new Blob([res]);
  //   let url = window.URL.createObjectURL(blob);
  //   let link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', name + '_' + moment().format("YYYYMMDDHHmmss") + '.xlsx');
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // },

  langCheck(lang) {
    let res = "";
    switch (lang) {
      case "cn":
        res = "cn"
        break;
      case "en":
        res = "en"
        break;
      case "tw":
        res = "tw"
        break;
      default:
        res = "cn"
        break;
    }
    return res
  },

// 节流: wait期间func只执行一次（根据func_name识别）
   taskArr:[],
   throttle(func, func_name,wait) {
    let self=this
    if(self.taskArr.indexOf(func_name)==-1){
      self.taskArr.push(func_name)
      func()
      setTimeout(_=>{
        self.taskArr.splice(self.taskArr.indexOf(func_name),1)
      },wait)
    }

}
}

export default util;



// WEBPACK FOOTER //
// ./src/libs/util.js